import { VNode } from "vue";

export enum CashFlowPeriodType {
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
}

export interface CashFlowCategoryAmount {
  id: string;
  name: string;
  amount: number;
}

export interface CashFlowSectionResult {
  section: "OPERATING" | "INVESTING" | "FINANCING";
  categories: CashFlowCategoryAmount[];
  subtotal: number;
}

export interface CashFlowColumnResult {
  dateFrom: string;
  dateTo: string;
  sections: CashFlowSectionResult[];
  netCashFlow: number;
  openingBalance: number;
  closingBalance: number;
}

export interface ColumnConfig<T> {
  title: string;
  dataIndex: string;
  key: string;
  colSpan?: number;
  align?: string;
  customCell?: (record: T) => Record<string, unknown>;
  customHeaderCell?: () => Record<string, unknown>;
  customRender?: (
    text: string,
    record: T
  ) => string | number | CustomRenderResult | VNode;
}

export interface CustomRenderResult {
  attrs?: {
    colSpan?: number;
    rowSpan?: number;
    class?: string;
  };
  colSpan?: number;
  rowSpan?: number;
  children?: string | number | VNode;
}

export interface CashFlowReportResponse {
  columns: CashFlowColumnResult[];
}

export interface CashFlowLineItem {
  accountCode: string;
  accountDescription: string;
  amount: number;
}

export interface CashFlowCategoryDetail {
  categoryId: string;
  categoryName: string;
  dateFrom: string;
  dateTo: string;
  totalAmount: number;
  items: CashFlowLineItem[];
}

export interface CashFlowReportSectionTableRow {
  key: string;
  type: "category";
  rowType: "category";
  label: string;
  categoryId?: string;
  [key: string]: string | number | undefined;
}

export type Periods = {
  period_0?: string | number;
  period_1?: string | number;
  period_2?: string | number;
  period_3?: string | number;
  period_total?: string | number;
};

export type CashFlowReportTableRow = Periods & {
  key: string;
  type:
    | "section"
    | "category"
    | "subtotal"
    | "cashflow"
    | "opening-balance"
    | "closing-balance";
  rowType:
    | "section"
    | "category"
    | "subtotal"
    | "cashflow"
    | "opening-balance"
    | "closing-balance";
  label: string;
  categoryId?: string;
};
